// utils
import clamp from "./Clamp";

/**
 * This is kind of like .toFixed() but it will set a maximum number of decimal
 * places only if necessary.
 *
 * @param {Number} value - value to convert
 * @param {Number} maxDecimalPlaces - maximum number of decimal places
 */
const toFixed = (value, maxDecimalPlaces = 2) => {
	const decimalPlaces = clamp(maxDecimalPlaces, 0, 10);
	const newValue = Math.round(value * 10 ** decimalPlaces) / 10 ** decimalPlaces;

	if (Number.isNaN(newValue)) {
		return 0;
	}

	return newValue;
};

export default toFixed;
